module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"tab":{"article":"举报/阻挡帖子","brand_user":"举报/阻挡作者"},"spam_type_label":"举报事由 (必填)","reason_placeholder":"请在{max_length}字以内输入举报内容。","hint":"举报项目中未包含的内容请选择其他并填写举报内容。","hint2":"您举报的内容将在管理员审核后依照内部政策进行处理。","block_label":"是否阻挡","block_message":{"article":"阻挡该帖子。","brand_user":"阻挡该作者的所有帖子。"}}}')
  delete Component.options._Ctor
}
